// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"fq-z","breadcrumbForward":"gq-z","breadcrumbBack":"hq-z","selected":"iq-z"};